import React from "react";
import DOMPurify from 'dompurify';

export const ValidationErrorsHtml = (keyGuid: string, errors: ValidationError[]) : JSX.Element => {
  if(!errors) {
    return (null);
  }

  const renderedErrors = errors.map((error) => { 

    if(error.html === undefined) {
      return (null);
    }

    const cleanHtmlString = DOMPurify.sanitize(error.html);

    return (
      <div className="form-group additional-html-error" key={keyGuid + "_error_html"}>
        <label dangerouslySetInnerHTML={{ __html: cleanHtmlString }}></label>
      </div>
    );
  });

  return (<>{renderedErrors}</>);
};

export const ValidationErrorsMessages = ({keyGuid, errors} : ValidationErrorMessages) : JSX.Element => {
  if(!errors) {
    return (null);
  }

  const renderedErrors =  errors.map((error, index) => {     
    
    const cleanHtmlString = DOMPurify.sanitize(error.message);

    const tempElement = document.createElement('div');
    tempElement.innerHTML = cleanHtmlString;

    // Get the plain text content
    const plainText = tempElement.innerText || tempElement.textContent;

    return (
      <div className="form__invalid-feedback" key={`${keyGuid}_errors_${index}`}>
        {plainText}
      </div>
    );
  });

  return (<>{renderedErrors}</>);
};

export const ValidationCheckMark = ({required, hasErrors, formDataEntry, hasFocus} : ValidationCheckmark) : JSX.Element => {
  if(!required || hasErrors || !formDataEntry.touched || hasFocus) {
    return (null);
  }
 
  return (
    <div className="input-group-append form-control--is-valid-indicator">
      <div className="input-group-text">
        <span className="icon icon-checkmark"></span>
      </div>
    </div>
  );
};